import { useEffect, useState } from "react";
import axios from "axios";
import { Input } from "@/components/ui/input";
import { Search, MapPin, Calendar, Clock, ArrowRight, Loader2 } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicEventsSection() {
  const [events, setEvents] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => {
      setLoading(true);
      axios.get(`${API}/public/events`, { params: search.trim() ? { search: search.trim() } : {} })
        .then((r) => setEvents(r.data))
        .catch(() => setEvents([]))
        .finally(() => setLoading(false));
    }, 350);
    return () => clearTimeout(t);
  }, [search]);

  const openEvent = (token) => {
    window.location.hash = `#/event/${token}`;
  };

  return (
    <section className="bg-slate-50 border-t border-border py-10 px-4" data-testid="public-events-section">
      <div className="max-w-5xl mx-auto space-y-5">
        <div className="text-center space-y-1">
          <h2 className="font-heading text-2xl font-bold tracking-tight" data-testid="events-section-title">Upcoming Events</h2>
          <p className="text-sm text-muted-foreground">Select Event &amp; Apply Now</p>
        </div>
        <div className="max-w-md mx-auto relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-muted-foreground" />
          <Input
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search Event"
            className="pl-9"
            data-testid="events-search-input"
          />
        </div>
        {loading ? (
          <div className="flex justify-center py-10"><Loader2 className="h-6 w-6 animate-spin text-cyan-600" /></div>
        ) : events.length === 0 ? (
          <p className="text-center text-sm text-muted-foreground py-8" data-testid="events-empty">
            {search.trim() ? "Is search se koi event nahi mila." : "Abhi koi event live nahi hai."}
          </p>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            {events.map((ev, i) => (
              <button
                key={ev.share_token}
                onClick={() => openEvent(ev.share_token)}
                data-testid={`event-card-${i}`}
                className="text-left bg-white border border-border rounded-2xl overflow-hidden shadow-sm hover:shadow-md hover:-translate-y-0.5 transition-all duration-200 cursor-pointer"
              >
                {ev.banner ? (
                  <img src={ev.banner} alt={ev.name} className="w-full aspect-[1200/630] object-cover" />
                ) : (
                  <div className="w-full aspect-[1200/630] bg-slate-900 flex items-center justify-center">
                    <img src="/logo.webp?v=2" alt="" className="h-12 w-12 rounded-lg opacity-80" />
                  </div>
                )}
                <div className="p-4 space-y-2">
                  <p className="font-heading font-bold leading-snug" data-testid={`event-card-name-${i}`}>{ev.name}</p>
                  {(ev.city || ev.event_date || ev.event_time) && (
                    <div className="flex flex-wrap gap-x-3 gap-y-1 text-xs text-slate-600">
                      {ev.city && <span className="inline-flex items-center gap-1"><MapPin className="h-3 w-3 text-pink-600" />{ev.city}</span>}
                      {ev.event_date && <span className="inline-flex items-center gap-1"><Calendar className="h-3 w-3 text-pink-600" />{ev.event_date}</span>}
                      {ev.event_time && <span className="inline-flex items-center gap-1"><Clock className="h-3 w-3 text-pink-600" />{ev.event_time}</span>}
                    </div>
                  )}
                  <span className="inline-flex items-center gap-1.5 text-xs font-semibold text-cyan-700">
                    Register Here <ArrowRight className="h-3.5 w-3.5" />
                  </span>
                </div>
              </button>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
